<template>
  <div class="intro">
    <div class="title">
      <div class="title-t">
        <img src="@/common/images/productCenter/A1/l1822.png" alt="" />
        <span>德财院</span>
        <img src="@/common/images/productCenter/A1/l1823.png" alt="" />
      </div>
    </div>
    <div>
      <img
        class="dcjtImg"
        src="@/common/images/about/C01_dcjyxt/dcjyxt.png"
        alt=""
      />
      <div class="dcjtTit">德品载物  财济天下</div>
    </div>
    <!-- <div class="boxin banmain videoBox">
      <video
        class="videoDB"
        id="videoDB"
        autoplay
        controls
        :src="videoSrc"
        type="video/mp4"
      ></video>
      <div class="play" v-if="playingout" id="play" @click="playVideo">
        <img
          src="@/common/images/productCenter/A1/paly.png"
          id="playbtn"
          class="playbtn"
          alt=""
        />
      </div>
      <img
        src="@/common/images/productCenter/A1/palying.png"
        class="playing"
        v-if="playing"
        alt=""
      />
    </div> -->
    <div class="com">
      <div>
        深圳德讯证顾为全面贯彻落实证监会提出的“将投资者教育全面纳入国民教育体系”政策要求，切实履行投资者教育职责，特于2022年发起创办德财院。旨在帮助中国资本市场中小投资者重新构建系统、职业、成熟的投资交易体系，推动粤港澳大湾区资本市场健康稳定发展。
      </div>
      <div>
        德财院倡导“授人以渔，蒙以为正”的教学宗旨，在中国资本市场的黄金时代下，德财院倾力打造优质的投资财技，解析投资者容易出现的交易误区，从投资实战根本出发，深入浅出讲解简单易行的投资精要方法和交易实战技巧。
      </div>
      <div>
        从实战交易的低、中、高频，多角度、全方位、深层次的解决投资者交易痛点，帮助投资者高效提升实战技能、树立正确投资理念、打开投资智慧法门。通过为投资者持续输出实战技法、交易体系、投资心学等内容，让投资者通过学习，真正做到在投资世界中，见天地、见众生、见自己。
      </div>
      <div class="com_yinSi" @click="toDetail">隐私保护政策></div>
    </div>
    
    <!-- <div class="threebox">
      <div class="tbox">
        <div class="tbox_t">经营理念</div>
        <div class="tbox_p tbox_p_c">以客户需求为中心</div>
      </div>
      <div class="tbox">
        <div class="tbox_t">企业使命</div>
        <div class="tbox_p">
          致力于为中国投资人孵化财富，为非专业投资人搭建学习平台和再投资通道，让每个人都能成为合格的投资者
        </div>
      </div>
      <div class="tbox">
        <div class="tbox_t">企业愿景</div>
        <div class="tbox_p">力争成为粤港澳大湾区专业证券顾问行业标杆</div>
      </div>
    </div>
    <div class="borImg"></div>
    <div class="icon">
      <div class="iconCard">
        <div class="iconImg"></div>
        <div class="iconTXT">
          <div class="iconTXT1">资讯金融</div>
          <div class="iconTXT2">权威的财经资讯移动平台</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="iconCard">
        <div class="iconImg" id="iconImg2"></div>
        <div class="iconTXT" style="width: 160px">
          <div class="iconTXT1">数据金融</div>
          <div class="iconTXT2">高度整合实时行情数据</div>
        </div>
      </div>
      <div class="line"></div>

      <div class="iconCard">
        <div class="iconImg" id="iconImg3"></div>
        <div class="iconTXT">
          <div class="iconTXT1">教育金融</div>
          <div class="iconTXT2">专业轻松的投资学习平台</div>
        </div>
      </div>
      <div class="line"></div>

      <div class="iconCard">
        <div class="iconImg" id="iconImg4"></div>
        <div class="iconTXT">
          <div class="iconTXT1">投顾金融</div>
          <div class="iconTXT2">多维度投顾服务管理系统</div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "A01_gsjj",
  data() {
    return {
      videoSrc: "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/about.mp4",
      playingout: true,
      playing: false,
    };
  },
  mounted() {
    // this.playState();
  },
  methods: {
    //大德精研视频播放
    // playVideo: function () {
    //   let video = document.getElementById("videoDB");
    //   if (video.paused) {
    //     video.play();
    //   } else {
    //     video.pause();
    //   }
    // },
    // playState: function () {
    //   let that = this;
    //   let ele = document.getElementById("videoDB");
    //   ele.addEventListener("play", function () {
    //     //播放开始执行的函数
    //     //console.log(1);
    //     that.playing = true;
    //     that.playingout = false;
    //     let s = setTimeout(function () {
    //       that.playing = false;
    //       clearTimeout(s);
    //     }, 1000);
    //   });
    //   ele.addEventListener("pause", function () {
    //     //暂停开始执行的函数
    //     //console.log(0);
    //     that.playingout = true;
    //   });
    // },
    toDetail: function (str) {
      this.$router.push({
        name: "C01_dcjys",
        query: {
          str: 'dcjys',
        },
      });
    },
  },
};
</script>
<style scoped>
.intro {
  width: 1170px;
  overflow: hidden;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  margin-left: 236px;
  min-height: 940px;
}
.title {
  width: 100%;
}
.title-t {
  display: flex;
  justify-content: center;
  align-items: center;
}
.title-t span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.title-b {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999999;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 4px;
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 710px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
.com {
  width: 1146px;
  margin: 0 auto;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 48px;
  color: #333333;
  opacity: 1;
  text-align: left;
}
.com_yinSi{
  cursor: pointer;
  margin-top: 110px;
}
.borImg {
  width: 700px;
  height: 19px;
  background: url("../../common/images/about/A01_gsjj/borImg.png") no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 40px;
}
.icon {
  width: 100%;
  display: flex;
  margin: 0 auto;
  margin-top: 38px;
}
.iconCard {
  display: flex;
}
.iconImg {
  width: 60px;
  height: 60px;
  background: url("../../common/images/about/A01_gsjj/icon1.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 20px;
}
.iconTXT {
  width: 176px;
  text-align: left;
}
.iconTXT1 {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 30px;
  color: #333333;
  opacity: 1;
}
.iconTXT2 {
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 30px;
  color: #505050;
  opacity: 0.88;
}
.line {
  width: 0px;
  height: 59px;
  border: 1px solid #dbdbdb;
  opacity: 1;
  margin: 5px 26px 0 26px;
}
#iconImg2 {
  height: 65px;
  background: url("../../common/images/about/A01_gsjj/icon2.png") no-repeat;
  background-size: 100% 100%;
}
#iconImg3 {
  background: url("../../common/images/about/A01_gsjj/icon3.png") no-repeat;
  background-size: 100% 100%;
}
#iconImg4 {
  background: url("../../common/images/about/A01_gsjj/icon4.png") no-repeat;
  background-size: 100% 100%;
}
.video {
  width: 980px;
  height: 551px;
  background-color: #ccf;
  margin: 0px 0 60px 152px;
}

.videoBox {
  position: relative;
  width: 980px;
  height: 550px;
  margin: 30px auto;
}
.videoDB {
  width: 100%;
  height: 100%;
}
.videoBox .play {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 400px;
  background: linear-gradient(rgba(80, 80, 80, 0.3), rgba(80, 80, 80, 0));
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  cursor: pointer;
}
.videoBox .playbtn {
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 120px;
}
.videoBox .playing {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -60px;
}
.threebox {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 40px;
}
.tbox {
  width: 310px;
  height: 350px;
  background: url("../../common/images/about/A01_gsjj/threebox.png");
}
.tbox:nth-child(2) {
  margin: 0 80px;
}
.tbox_t {
  width: 104px;
  height: 37px;
  font-size: 26px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 37px;
  margin: 0 auto;
  margin-top: 40px;
}
.tbox_p {
  width: 224px;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #4d4d4d;
  line-height: 34px;
  margin: 0 auto;
  margin-top: 24px;
  text-align: left;
}
.tbox_p_c {
  text-align: center;
}
.dcjtImg {
  width: 280px;
  /* height: 250px; */
}
.dcjtTit {
  height: 56px;
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: bold;
  /* line-height: 56px; */
  color: #1d1d1d;
  opacity: 1;
  margin: -30px 0px 10px 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/C01_dcjyxt.vue